import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "development-card-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["development-card", { disabled: _ctx.disabled }])
  }, [
    (!_ctx.noIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "D"))
      : _createCommentVNode("", true)
  ], 2))
}